module.exports = __webpack_public_path__ + "static/media/floral_02.23a5c471.png";